<template>
  <div class="public_navBox">
		<div class="Logo">
			<img @click.stop="jumpLogo()" src="../assets/logo_all.png" alt="">
		</div>
		<div class="nav">
			<div class="nav-menu">
				<div class="nav-item" :class="{ '_active': $route.path === '/' }" @click="handleNavigate('/')">首页</div>
				<div class="nav-item package-item" :class="{ '_active': $route.path === '/package' }" @click="handleNavigate('/package')">
					<span class="package-badge" :class="{ 'badge-blink': $route.path !== '/package' }">超低价体验</span>
					套餐
				</div>
				<div class="nav-item" :class="{ '_active': $route.path === '/topup' }" @click="handleNavigate('/topup')">充值</div>
				<div class="nav-item" :class="{ '_active': $route.path === '/accessApi' }" @click="handleNavigate('/accessApi')">获取 API</div>
				<div class="nav-item" :class="{ '_active': $route.path === '/channel' }" @click="handleNavigate('/channel')">企业通道</div>
				<div class="nav-item" :class="{ '_active': $route.path === '/newhelp' }" @click="handleNavigate('/newhelp')">帮助中心</div>
			</div>
		</div>
		<div class="LogStus" v-if="!sessionType">
			<p class="login" @click.stop="_login(1)">登录</p>
			<p class="register" @click.stop="_login(2)">注册</p>
			<!-- <div class="_dialogue">
				<span class="_gift">注册免费送100元，每天可领</span>
			</div> -->
			
		</div>
		<div class="LogStus" v-if="sessionType">
			<!-- <span class="_userName">{{name}}</span> -->
			<el-tooltip class="item" effect="dark" :content="name" placement="bottom">
					<img @click.stop="jumpMine()" class="_info" src="../assets/infos.png" alt="">
			</el-tooltip>
			<p class="login" @click.stop="exit()">退出登录</p>
			<!-- <p class="register" @click.stop="_login(2)">注册</p> -->
		</div>
  </div>
</template>

<script>
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'Nav',
  props: {

	},
  data(){
    return{
			sessionType:false,
			name:'',
			visible:true,
    }
	},
	computed:{
		route() {
      return this.$route.path
		},
		sessionid(){
			return localStorage.getItem('access_token');
		},
		access_tokens(){
			return this.$store.state.access_token
		},
		userName(){
			return localStorage.getItem('username');
		},
		userNameInStorage(){
			return localStorage.getItem('name');
		},
	},
	watch:{
		'userNameInStorage':{
			handler(value){
				if(value){
					this.name = value
				}
      },
      immediate: true,
      deep: true 
		},
		'userName':{
			handler(value){
				if(value && !this.name){
					this.name = value
				}
      },
      immediate: true,
      deep: true 
		},
		'access_tokens':{
			handler(value){
				if(value !== null){
					this.sessionType = true 
				}else{
					this.sessionType = false
				}
				// this.activeLi = value ? value : (sessionStorage.getItem("MineActiveLi") ? sessionStorage.getItem("MineActiveLi") : 0)
			},
			immediate: true,
			deep: true 
		},

		'sessionid':{
			handler(value){
				if(value){
					this.sessionType = true
				}else{
					this.sessionType = false
				}
      },
      immediate: true,
      deep: true 
		},
	},
  created(){

  },
  methods:{
		handleNavigate(path){
			// 如果点击的是当前页面，不处理
			if (path === this.$route.path) {
				return
			}
			this.$router.push({ path: path })
		},
		jumpLogo(){
			this.$router.push({ path: '/' })
		},
		exit(){
			let data = {
				access_token:localStorage.getItem('access_token')
			}
			request({
				method: 'post', 
				url: Apis.logout,
				params:data
			}).then(res => {
				this.$store.commit("setaccess_token", null);
				localStorage.removeItem('name');
				localStorage.removeItem('id');
				localStorage.removeItem('username');
				localStorage.removeItem('userpass');
				localStorage.removeItem('access_token');
				// 重置登录框标志
				const { resetLoginFlag } = require('@/router/index.js')
				resetLoginFlag()
				// 跳转到首页并刷新
				this.$router.push('/')
				setTimeout(() => {
					window.location.reload()
				}, 100)
			});
		},
		handleSelect(cal){
			// 保存点击的路径
			this.clickedPath = cal
			this.$router.push({ path: cal })
		},
		returnTitle(){
      return this.$route.path
		},
		_login(type){
			this.$store.commit("setLoginType", true);
			if(type == 1){
				this.$store.commit("setRegisterType", '1');
			}else{
				this.$store.commit("setRegisterType", '2');
			}
		},
		jumpMine(){
			this.$router.push({ path: '/mine' })
			this.$store.commit("setMineActiveLi", 0);
		}
		// this.$store.commit("setOperateShow", '2');
  }
}
</script>

<style scoped lang="less">
.public_navBox{
	width: 100%;
	height: 90px;
	// background: palegreen;
	display: flex;
	justify-content: center;
	align-items: center;
	.Logo{
		margin-right: 80px;
		img{
			width: 100%;
			height: 100%;
			cursor: pointer;
		}
	}
	.Nav{
		// width: ;
	}
	.LogStus{
		width: 224px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		

		._dialogue{
			background-color: #FF4646;
			margin:50px auto;
			width:220px;height:25px;
			border-radius: 10px;
			position: absolute;
			top: 20px;
			left: 32%;
			z-index: 99;
			font-size: 12px;
			color: #fff;	
			line-height: 28px;

			._gift::before{
				content: '';
				display: inline-block;
				width: 12px;
				height: 12px;
				background: url("../assets/_gift_1.png")no-repeat;
				background-size: 100% 100%;
				position: relative;
				left: -2px;
			}

		}
		._dialogue::before{
			content:" ";
			border-left: 8px solid transparent;
			border-top:0px solid #FF4646;
			border-right:8px solid transparent;
			border-bottom:10px solid #FF4646;
			position: absolute;left:90px;top:-10px;
    }
		.item{
			cursor: pointer;
		}
		.item{
			cursor: pointer;
		}
		// position: relative;
		// ._userName{
		// 	padding:0 10px;
		// }
		p{
			width: 92px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			border-radius: 19px;
			font-size: 14px;
			border: 1px solid #ccc;
			margin: 0 10px;
			cursor: pointer;
		}
		.register{
			background: #1F8EFF;
			color: #fff;
			border: none;
		}
		._info{
			width: 30px;
			height: 30px;
			border-radius: 50%;
			overflow: hidden;
		}
	}
}
 @media screen and (max-width: 1200px) {
	 .public_navBox{
		 min-width:1000px;
	 	// width:expression(document.body.clientWidth < 1000px? "1000px": "auto" );
	 }
	 
 }
</style>
<style scoped>
.public_navBox >>> .el-menu.el-menu--horizontal{
	border-bottom:none;
}
.public_navBox >>> .el-menu{
	background-color: #ffffff00;
}
.public_navBox >>> .el-menu--horizontal>.el-menu-item{
	color: #242323;
	font-size: 14px;
	height:40px;
	line-height: 40px;
}

/* 套餐标签 - 超低价体验 */
.public_navBox >>> .el-menu-item.package-with-badge {
	position: relative;
}
.public_navBox >>> .el-menu-item.package-with-badge .badge-text {
	position: absolute;
	top: -15px;
	left: 50%;
	transform: translateX(-50%);
	display: inline-block;
	background: linear-gradient(90deg, #FF4646 0%, #FF6B6B 100%);
	color: #fff;
	font-size: 11px;
	padding: 4px 10px;
	border-radius: 10px;
	white-space: nowrap;
	font-weight: 500;
	box-shadow: 0 2px 6px rgba(255, 70, 70, 0.3);
	z-index: 10;
	line-height: 1.2;
}
.public_navBox >>> .el-menu-item.package-with-badge .badge-text::after {
	content: '';
	position: absolute;
	bottom: -4px;
	left: 50%;
	transform: translateX(-50%);
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-top: 4px solid #FF4646;
}

/* 徽章闪烁效果 - 非套餐页显示 */
.public_navBox >>> .el-menu-item.package-with-badge.badge-blink .badge-text {
	animation: badge-blink 2s ease-in-out infinite;
}
@keyframes badge-blink {
	0%, 100% {
		opacity: 1;
		transform: translateX(-50%) scale(1);
	}
	50% {
		opacity: 0.6;
		transform: translateX(-50%) scale(0.95);
	}
}

._dialogue{
	/* animation: fade 500ms infinite;
	-webkit-animation: fade 600ms infinite; */
}
@keyframes fade {
	from {
			opacity: 1.0;
	}
	50% {
			opacity: 0.4;
	}
	to {
			opacity: 1.0;
	}
}

@-webkit-keyframes fade {
	from {
			opacity: 1.0;
	}
	50% {
			opacity: 0.4;
	}
	to {
			opacity: 1.0;
	}
}

</style>


<style scoped lang="less">
.nav-menu {
  display: flex;
  align-items: center;
  gap: 20px;
  
  .nav-item {
    padding: 8px 16px 8px;
    cursor: pointer;
    color: #242323;
    font-size: 14px;
    position: relative;
    transition: all 0.3s;
    &:hover {
      color: #51B3FF;
    }
    
    &._active {
      color: #51B3FF;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 2px;
        background: #51B3FF;
      }
    }
    
    &.package-item {
      position: relative;
    	//   padding-top: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      
      .package-badge {
        position: absolute;
        top: -8px;
        left: 50%;
        transform: translateX(-50%);
        background: linear-gradient(90deg, #FF4646 0%, #FF6B6B 100%);
        color: #fff;
        font-size: 10px;
        padding: 2px 8px;
        border-radius: 10px;
        white-space: nowrap;
        font-weight: 500;
        box-shadow: 0 2px 6px rgba(255, 70, 70, 0.3);
        z-index: 10;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -3px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          border-top: 3px solid #FF4646;
        }
        
        &.badge-blink {
          animation: badge-blink 2s ease-in-out infinite;
        }
      }
      
      @keyframes badge-blink {
        0%, 100% {
          opacity: 1;
          transform: translateX(-50%) scale(1);
        }
        50% {
          opacity: 0.6;
          transform: translateX(-50%) scale(0.95);
        }
      }
      
      span:last-child {
        margin-top: -4px;
      }
    }
  }
}
</style>
